module.exports = __webpack_public_path__ + "img/map_Z4.2.A.01.54db2fcd.svg";